import { Injectable, signal, WritableSignal, inject } from '@angular/core';

import { SessionStorageService } from '../../shared/services/session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SectorToastService {
  public isVisible: WritableSignal<boolean> = signal(false);
  public sector: WritableSignal<string | null> = signal(null);
  public companyTicker: WritableSignal<string | null> = signal(null);
  private readonly STORAGE_KEY = 'sector-toast-minimized';
  private sessionStorage = inject(SessionStorageService);

  update(sector: string, companyTicker: string) {
    if (!sector || !companyTicker) return;

    this.sector.set(sector);
    this.companyTicker.set(companyTicker);

    // Always show the toast on new company page visit unless explicitly minimized
    const isMinimized = this.sessionStorage.getBoolean(this.STORAGE_KEY);
    if (!isMinimized) {
      this.show();
    }
  }

  show() {
    this.isVisible.set(true);
    this.sessionStorage.remove(this.STORAGE_KEY);
  }

  hide() {
    this.isVisible.set(false);
    this.sessionStorage.setBoolean(this.STORAGE_KEY, true);
  }

  toggle() {
    if (this.isVisible()) {
      this.hide();
    } else {
      this.show();
    }
  }
}
